<template>
    <b-container fluid class="animated fadeIn">
        <h1>Protesto - Exibir CDAs Excluídas</h1>
        <b-card>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button class="mx-1 fonte-branca" v-b-toggle.collapseOpcoesPesquisa variant="primary"><i class="fa fa-filter"></i> Opções de pesquisa</b-button>
                            <CompExibirOcultarColuna
                                    :fields="fields"
                                    :showColunms="showColunms"
                                    @toggleColuna="toggleColuna" />
                        </div>
                    </div>
                    <div>
                        <b-collapse id="collapseOpcoesPesquisa" class="mt-2">
                            <b-card class="primary-semi p-2">
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Filtrar por:" label-for="filtrarPor" class="text-label">
                                            <multiselect
                                                    v-model="filtrarPor"
                                                    :show-labels="false"
                                                    :options="opcoesFiltro"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :preserve-search="true"
                                                    placeholder="Selecione"
                                                    track-by="id"
                                                    label="filtro"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span
                                                            class="multiselect__single"
                                                            v-if="values.length &amp;&amp; !isOpen"
                                                    >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 1).length > 0)">
                                    <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                                        <b-form-group label="Nº da Dívida:" label-for="numeroDivida" class="text-label">
                                            <b-form-input v-model="filtro.numeroDivida" type="number" id="numeroDivida" maxlength="8" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 2).length > 0)">
                                    <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                                        <b-form-group label="CPF/CNPJ:" label-for="cpfCnpj" class="text-label">
                                            <the-mask
                                                    id="cpfCnpj"
                                                    class="form-control"
                                                    v-model="filtro.cpfCnpj"
                                                    :mask="['XX.XXX.XXX/XXXX-##', 'XXX.XXX.XXX-XX']"
                                            />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 3).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Contribuinte:" label-for="contribuinte" class="text-label">
                                            <b-form-input v-model="filtro.contribuinte" type="text" id="contribuinte" maxlength="100" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 4).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="CADICMS:" label-for="cadicms" class="text-label">
                                            <b-form-input v-model="filtro.cadicms" type="text" id="cadicms" maxlength="20" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 5).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Comarca:" label-for="comarcas" class="text-label">
                                            <multiselect
                                                    v-model="filtro.comarcas"
                                                    :show-labels="false"
                                                    :options="dados.comarcas"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :preserve-search="true"
                                                    placeholder="Selecione"
                                                    label="nome"
                                                    track-by="codComarca"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                  <span
                                                          class="multiselect__single"
                                                          v-if="values.length &amp;&amp; !isOpen"
                                                  >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 6).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Tipo de Crédito:" label-for="tipoCredito" class="text-label">
                                            <multiselect
                                                    v-model="filtro.tipoCredito"
                                                    :show-labels="false"
                                                    :options="dados.creditos"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :preserve-search="true"
                                                    placeholder="Selecione"
                                                    label="nome"
                                                    track-by="id"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                  <span
                                                          class="multiselect__single"
                                                          v-if="values.length &amp;&amp; !isOpen"
                                                  >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 7).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data de Inscrição (Início):" label-for="dataInscricaoInicial" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dataInscricaoInicial"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data de Inscrição (Fim)" label-for="dataInscricaoFinal" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dataInscricaoFinal"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 8).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Motivo:" label-for="motivo" class="text-label">
                                            <multiselect
                                                    v-model="filtro.motivo"
                                                    :show-labels="false"
                                                    :options="dados.motivos"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :preserve-search="true"
                                                    placeholder="Selecione"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                  <span
                                                          class="multiselect__single"
                                                          v-if="values.length &amp;&amp; !isOpen"
                                                  >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 9).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Pgto (Início):" label-for="dataPagamentoInicial" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dataPagamentoInicial"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Pgto (Fim)" label-for="dataPagamentoFinal" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dataPagamentoFinal"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <hr>
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <b-button variant="primary" class="fonte-branca" @click="filtrar">
                                                <i class="fa fa-search"></i> Pesquisar
                                            </b-button>
                                            <b-button class="ml-2" variant="secondary" @click="limparFiltro">
                                                <i class="fa fa-eraser"></i> Limpar
                                            </b-button>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-collapse>
                    </div>
                    <b-row class="d-flex justify-content-between mt-2">
                        <b-col align-self="end">
                            <div class="d-flex justify-content-between mb-3" style="float:right">
                                <div>
                                    <b-button class="mx-1" variant="primary" @click.prevent="encaminharDisponiveis" :disabled="selecteds.length < 1 || !dataCorrenteAtual"><i class="fa fa-pencil-square-o"></i> Encaminhar para Disponíveis</b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col xs="12" md="12" class="mx-auto">
                            <b-col xs="12">
                                <div>
                                    <b-row class="d-flex justify-content-between">
                                        <b-col>
                                            <label class="mt-3">Dívidas Excluídas - Valor Total: <strong>R$ {{ configTable.valorTotal | currency }}</strong> &nbsp; Quantidade: <strong>{{ configTable.rows }}</strong></label>
                                        </b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                    <CompTabelaCdaExcluida
                                        :resultado="resultado"
                                        :fields="fields"
                                        :configTable="configTable"
                                        :selecteds="selecteds"
                                        @sortingChanged="consultarDividas"
                                        @consultarDividas="consultarDividas" />
                                    <b-row class="d-flex justify-content-between">
                                        <b-col></b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-col>
                    </b-row>
                    <CompBotoesFooter
                        @exportCSV="exportCSV"
                        @voltar="voltar"
                        :loadCSV="loadCSV" />
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
    import axios from 'axios'
    import CompBotoesFooter from './components/CompBotoesFooter'
    import CompPaginacao from './components/CompPaginacao'
    import CompExibirOcultarColuna from './components/CompBotaoExibirOcultarColuna'
    import CompTabelaCdaExcluida from './components/CompTabelaCdaExcluida'

    export default {
        name: 'ExibirExcluidasProtesto',
        components: {
            CompBotoesFooter,
            CompPaginacao,
            CompExibirOcultarColuna,
            CompTabelaCdaExcluida
        },
        data() {
            return {
                ano: null,
                mes: null,
                dataCorrenteAtual: false,
                filtrarPor: [],
                opcoesFiltro: [
                    {
                        id: 1,
                        filtro: 'Número da Dívida'
                    },
                    {
                        id: 2,
                        filtro: 'CPF/CNPJ'
                    },
                    {
                        id: 3,
                        filtro: 'Contribuinte'
                    },
                    {
                        id: 4,
                        filtro: 'CAD ICMS'
                    },
                    {
                        id: 5,
                        filtro: 'Comarca'
                    },
                    {
                        id: 6,
                        filtro: 'Tipo de Crédito'
                    },
                    {
                        id: 7,
                        filtro: 'Data Inscrição'
                    },
                    {
                        id: 8,
                        filtro: 'Motivo'
                    },
                    {
                        id: 9,
                        filtro: 'Pgto'
                    }
                ],
                filtro: {
                    numeroDivida: null,
                    cpfCnpj: null,
                    contribuinte: null,
                    cadicms: null,
                    comarcas: null,
                    tipoCredito: null,
                    dataInscricaoInicial: null,
                    dataInscricaoFinal: null,
                    motivo: null,
                    dataPagamentoInicial: null,
                    dataPagamentoFinal: null
                },
                dados: {
                    comarcas: [],
                    creditos: [],
                    motivos: []
                },
                configTable: {
                    perPage: 100,
                    sortField: 'inicial',
                    sortOrder: 'asc',
                    currentPage: 1,
                    rows: 0,
                    load: false,
                    checkedAll: false,
                    valorTotal: 0.00
                },
                showColunms: [],
                fields: [
                    {
                        key: "selecionar",
                    },
                ],
                resultado: [],
                loadCSV: false,
                selecteds: [],
            }
        },
        watch: {
            perPage() {
                this.configTable.currentPage = 1;
                this.consultarDividas();
            }
        },
        computed: {
            perPage() {
                return this.configTable.perPage;
            }
        },
        methods: {
            limparFiltro() {
                this.filtrarPor = [];
                this.filtro = {
                    numeroDivida: null,
                    cpfCnpj: null,
                    contribuinte: null,
                    cadicms: null,
                    comarcas: null,
                    tipoCredito: null,
                    dataInscricaoInicial: null,
                    dataInscricaoFinal: null,
                    motivo: null,
                    dataPagamentoInicial: null,
                    dataPagamentoFinal: null
                }
            },
            toggleColuna(i) {
                let ativo;
                if(this.showColunms.includes(i)) {
                    this.showColunms.splice(this.showColunms.indexOf(i), 1);
                    this.fields[i].thClass = 'd-none';
                    this.fields[i].tdClass = 'd-none';
                    ativo = false
                } else {
                    this.showColunms.push(i);
                    this.fields[i].thClass = '';
                    this.fields[i].tdClass = '';
                    ativo = true
                }

                this.refreshConfigColunm(i, ativo)
            },
            async refreshConfigColunm(i, ativo) {
                const token = JSON.parse(this.$store.getters.getUser).access_token;

                const json = {
                    codFuncionalidade: this.fields[i].codFuncionalidade,
                    codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                    ativo: ativo,
                };
                const urlApi = process.env.VUE_APP_ROOT_API;

                axios.post(`${urlApi}/v1/funcionalidade/atualizarConfiguracao`, json, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                })
            },
            checkClassTable(i) {
                if(i == 0 || i == 4 || i == 6 || i == 7 || i == 9)
                    return 'text-center';
                if(i == 1 || i == 2 || i == 3 || i == 8)
                    return 'text-left';
                if(i == 5)
                    return 'text-right';
                return ''
            },
            async exportCSV() {
                const urlApi = process.env.VUE_APP_ROOT_API;

                if(this.configTable.rows == 0) {
                    this.$store.commit("setMessages", { message: 'Erro!', errors: ["Não há registros a serem exportados."] });
                } else {
                    this.loadCSV = true;
                    const token = JSON.parse(this.$store.getters.getUser).access_token;
                    const funcionalidade = 'cdaExcluidaProtesto';


                    if(this.selecteds.length <= 0){
                        const filtro = this.obterFiltro();
                        axios.post(`${urlApi}/v1/cdaExcluidaProtesto/exportarCsv/${this.ano}/${this.mes}/${funcionalidade}?page=${this.configTable.currentPage}` + this.escapePerPage() + `&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': token
                                }
                            })
                                .then(response => {
                                const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'CDAExcluidasProtesto.csv');
                            document.body.appendChild(link);
                            link.click();
                        }).finally(() => {
                            this.loadCSV = false
                        })
                    } else {
                        axios.post(`${urlApi}/v1/cdaExcluidaProtesto/exportarCsvSelecionadas/${this.ano}/${this.mes}/${funcionalidade}?sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.selecteds, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': token
                            }
                        }).then(response => {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'CDAExcluidasProtesto.csv');
                            document.body.appendChild(link);
                            link.click();
                        }).finally(() => {
                            this.loadCSV = false
                        })
                    }
                }
            },
            voltar() {
                this.$router.push('/dashboard');
            },
            filtrar() {
                this.configTable.currentPage = 1;
                this.consultarDividas();
            },
            async consultarDividas() {
                const urlApi = process.env.VUE_APP_ROOT_API;
                this.loadingEnter();
                const filtro = this.obterFiltro();
                axios.post(`${urlApi}/v1/cdaExcluidaProtesto/consultar/${this.ano}/${this.mes}?page=${this.configTable.currentPage}` + this.escapePerPage() + `&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
                .then(response => {
                    this.resultado = response.data.resultado;
                    this.configTable.rows = response.data.rows;
                    this.configTable.valorTotal = response.data.valorTotal
                }).finally(() => {
                    this.loadingExit()
                })
            },
            async obterConfiguracaoUsuario(user) {
                const urlApi = process.env.VUE_APP_ROOT_API;
                const token = JSON.parse(this.$store.getters.getUser).access_token;
                const funcionalidade = 'cdaExcluidaProtesto';

                this.loadingEnter();
                axios.get(`${urlApi}/v1/funcionalidade/obterConfiguracao/${funcionalidade}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    response.data.forEach((field, i) => {
                        if(field.ativo) {
                            this.showColunms.push(i + 1);
                        }
                        this.fields.push({
                            key: `${i + 1}`,
                            label: `${field.descricao}`,
                            sortable: true,
                            sortDirection: "desc",
                            class: this.checkClassTable(i),
                            thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                            codColunaFuncionalidade: field.codColunaFuncionalidade,
                            codFuncionalidade: field.codFuncionalidade
                        })
                    })
                })
            },
            loadingEnter() {
                this.configTable.load = true
            },
            loadingExit() {
                this.configTable.load = false
            },
            async listarComarcas() {
                const urlApi = process.env.VUE_APP_ROOT_API;

                axios.get(`${urlApi}/v1/comarca/listar/protesto`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
                    .then(response => {
                        this.dados.comarcas = response.data
                })
            },

            async listarTipoCredito() {
                const urlApi = process.env.VUE_APP_ROOT_API;

                axios.get(`${urlApi}/v1/cdaDisponivelAjuizamento/listarTipoCredito`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
                    .then(response => {
                        this.dados.creditos = response.data
                })
            },

            escapePerPage() {
                if (this.configTable.perPage == 'Todos') {
                    return '';
                }
                return '&perPage='  + this.configTable.perPage
            },

            async listarMotivos() {
                const urlApi = process.env.VUE_APP_ROOT_API;

                const filtro = this.obterFiltro();

                axios.post(`${urlApi}/v1/cdaExcluidaProtesto/listarMotivos/${this.ano}/${this.mes}`, filtro, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                }).then(response => {
                    this.dados.motivos = response.data;
                })
            },

            obterFiltro() {
                return {
                    numeroDivida: (this.filtrarPor.filter(e => e.id == 1).length > 0) ? this.filtro.numeroDivida : null,
                    cpfCnpj: (this.filtrarPor.filter(e => e.id == 2).length > 0) ? this.filtro.cpfCnpj : null,
                    contribuinte: (this.filtrarPor.filter(e => e.id == 3).length > 0) ? this.filtro.contribuinte : null,
                    cadicms: (this.filtrarPor.filter(e => e.id == 4).length > 0) ? this.filtro.cadicms : null,
                    comarcas: (this.filtrarPor.filter(e => e.id == 5).length > 0) ? this.filtro.comarcas : null,
                    tipoCredito: (this.filtrarPor.filter(e => e.id == 6).length > 0) ? this.filtro.tipoCredito : null,
                    dataInscricaoInicial: (this.filtrarPor.filter(e => e.id == 7).length > 0) ? (this.filtro.dataInscricaoInicial ? this.filtro.dataInscricaoInicial.toString() : null) : null,
                    dataInscricaoFinal: (this.filtrarPor.filter(e => e.id == 7).length > 0) ? (this.filtro.dataInscricaoFinal ? this.filtro.dataInscricaoFinal.toString() : null) : null,
                    motivo: (this.filtrarPor.filter(e => e.id == 8).length > 0) ? this.filtro.motivo : null,
                    dataPagamentoInicial: (this.filtrarPor.filter(e => e.id == 9).length > 0) ? (this.filtro.dataPagamentoInicial ? this.filtro.dataPagamentoInicial.toString() : null) : null,
                    dataPagamentoFinal: (this.filtrarPor.filter(e => e.id == 9).length > 0) ? (this.filtro.dataPagamentoFinal ? this.filtro.dataPagamentoFinal.toString() : null) : null
                }
            },
            encaminharDisponiveis() {
                const urlApi = process.env.VUE_APP_ROOT_API;
                const token = JSON.parse(this.$store.getters.getUser).access_token;

                this.loadingEnter();
                axios.post(`${urlApi}/v1/cdaExcluidaProtesto/encaminharDisponiveis`, this.selecteds, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                }).then(() => {
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Encaminhamento para disponíveis executado com sucesso!'] });
                    this.selecteds = [];
                    this.configTable.checkedAll = false;
                }).finally(() => {
                    this.loadingExit();
                    this.consultarDividas();
                })
            }
        },
        created() {
            const user = this.$store.getters.getUser;
            const dataAtual = new Date(this.$store.getters.getDataMonitoramento);

            this.ano = dataAtual.getFullYear();
            this.mes = dataAtual.getMonth() + 1;

            var dataAtualSistema = new Date();
            this.dataCorrenteAtual = this.ano == dataAtualSistema.getFullYear() &&
                this.mes == (dataAtualSistema.getMonth() + 1);

            this.listarComarcas();
            this.listarTipoCredito();
            this.consultarDividas();
            this.obterConfiguracaoUsuario(user);
            this.listarMotivos();
        },

    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .fonte-branca {
        color: #FFF;
    }

    .fonte-branca:hover {
        color: #FFF;
    }

    .fonte-branca:active {
        color: #FFF !important;
    }

    .table-sub-item, .table-sub-item > th, .table-sub-item > td {
        background-color: rgb(237, 237, 238);
    }
</style>
